import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { CheckboxSelectListInput } from "components/Global/FormikMaterial";
import { TextInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelCheckboxSelectListInput = ({ label, fieldName, options, placeholder, formik, hasBorder, isDisabled, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const val = _.get(formik.values, fieldName);
  const refVal = _.get(formik.values, `${fieldName}Ref`);

  const getLabelByValue = () => {
    if (val === true || val === "1") {
      return "Yes";
    }

    return "No";
  };

  return (<LateralField label={label} hasBorder={hasBorder}>
    {isDisabled && (
      <Grid container item spacing={16}>
        <Grid item xs={10}>
          <ViewOnlyDiv>{getLabelByValue()}</ViewOnlyDiv>
        </Grid>
        <Grid item xs={2}>
          <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
        </Grid>
      </Grid>)}
    {!isDisabled && (
      <Grid container item spacing={16}>
        <Grid item xs={9}>
          <CheckboxSelectListInput
            label={placeholder}
            fieldName={fieldName}
            options={options}
            isDisabled={isDisabled}
            {...otherProps}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            fullWidth
            fieldName={`${fieldName}Ref`}
            placeholder="Add a reference"
            {...otherProps}
          />
        </Grid>
      </Grid>)}
          </LateralField>);
};
export default connect(SideLabelCheckboxSelectListInput);
